export const ICON_SIZE = 64
export const ICON_SIZE_SMALL = 33
